import React, { useRef, useState } from 'react';
import LeftMenu from '../components/LeftMenu';
import ChartDetails from '../components/ChatDetails';
import Groupinformation from '../components/Groupinformation';
import './whatsapp.css';
import { useContext } from 'react';
import filterContext from '../context/filters/filterContext';
import { useEffect } from 'react';
import ChatDetail from '../components/ChatDetails';
import io from 'socket.io-client';
import { useSelector } from 'react-redux';
import PreviewPage from '../components/PreviewPage';
import HomePage from './HomePagee.png';
import LoaderInitial from './LoaderInitial';
import getSocketInstance from './socket';

//TODO: Loadingscreen component
function Whatsapp() {
	const {
		fetchConversation,
		togChat,
		settogChat,
		getShortcuts,
		fetchChatConversation,
		selectedFiles,
		isPreviewPageVisible,
		setIsPreviewPageVisible,
		isChatOpen,
		setIsChatOpen,
		selectedFilesPdf,
		setselectedFilesPdf,
		pstate,
		setpstate,
		convId,
		getUsers,
		conversationdata,
		bool,
		setBool,
		specConv,
		setCreatedAt,
		setCreatedBy,
		setUnreadFlag,
		setOlderMessages,
		readConversationByUSer,
		setSenderId,
		setSenderName,
		setnamePerson,
		setpimgLink,
		setconvoId,
		setSelectedFiles,
		setPreviewURLs,
		setLastchat,
		setShowPopupClip,
		setIsPollMsgSelected,
		setdescription,
		setusersOfParticularGroup,
		setForwardCheckbox,
		setIsGroupEdited,
		setDisplayedUsersOfGroup,
		setSelectedMsgsForForward,
		setSelectedMsgsForDelete,
		setSelectedReceivedMsgs,
		setSelectedRedFlagMsgs,
		chatName,
	} = useContext(filterContext);

	const [isLoading, setIsLoading] = useState(true);

	useEffect(() => {
		setTimeout(() => {
			// Perform your action here
			fetchConversation();
			getShortcuts();
			getUsers();
		}, 500);
	}, []);
	useEffect(() => {
		if (bool && specConv) {
			handleChatFunc(specConv, conversationdata);
		}
	}, [conversationdata, bool, specConv]);

	function handleChatFunc(id, conversationdata) {
		let data = conversationdata.filter(ele => ele._id === id);
		// console.log('Hurray', conversationdata);
		// console.log('Hurray1', id);
		console.log('Ching', data[0].description);
		setIsChatOpen(true);
		setUnreadFlag(false);
		setOlderMessages(true);
		readConversationByUSer(data[0]?._id);
		setSenderId(user?._id);
		setSenderName(user?.name);
		setnamePerson(chatName(data[0]));
		setpimgLink(data[0]?.dp || window.config.favicon);
		setconvoId(data[0]?._id);
		settogChat(true);
		fetchChatConversation(data[0]?._id);
		setdescription(data[0]?.description);
		setCreatedBy(data[0]?.createdBy);
		setCreatedAt(data[0]?.createdAt);
		setusersOfParticularGroup(data[0]?.users);
		// fetchConversation();
		setDisplayedUsersOfGroup([]);
		setIsGroupEdited(false);
		setForwardCheckbox(false);
		setSelectedFiles([]);
		setPreviewURLs([]);
		setselectedFilesPdf([]);
		setIsChatOpen(true);
		setSelectedMsgsForForward([]);
		setSelectedMsgsForDelete([]);
		setSelectedReceivedMsgs([]);
		setIsPollMsgSelected([]);
		setSelectedRedFlagMsgs([]);
		setShowPopupClip(false);
		setLastchat(true);
		setBool(false);
	}

	const userSelector = state => state.user;

	const user = useSelector(userSelector);

	useEffect(() => {
		const socket = getSocketInstance(user);
		const connectSocket = () => {
			socket.emit('root/add-client', {
				device: 'Web',
				deviceId: 'Root',
				socketId: socket.id,
				user: user._id,
			});
			console.log(socket);
		};

		connectSocket();

		// Clean up the socket connection on component unmount
		return () => {
			if (socket) {
				socket.disconnect();
			}
		};
	}, [user]);

	useEffect(() => {
		setTimeout(() => {
			setIsLoading(false);
		}, 3000); // Set loading time to 3 seconds
	}, []);

	if (isLoading) {
		return <LoaderInitial />;
	}

	return (
		//main container

		<div className="main-container">
			{/* 2 components container */}
			<div className="components-container whatsapp-bp:justify-center">
				{/* Left menu of chat */}
				<div className="left-menu">
					<LeftMenu />
				</div>
				{/* ChatDetail */}
				<div
					className={`chat-detail ${isPreviewPageVisible ? 'preview-mode' : ''}`}
					style={{
						display: `${!isChatOpen ? 'flex' : ''}`,
						justifyContent: `${!isChatOpen ? 'center' : ''}`,
						alignItems: `${!isChatOpen ? 'center' : ''}`,
						textAlign: `${!isChatOpen ? 'center' : ''}`,
					}}
				>
					<>
						{selectedFiles.length > 0 ? (
							<>
								{setpstate(false)} {/* This will set pstate to false */}
								<PreviewPage />
							</>
						) : selectedFilesPdf.length > 0 ? (
							<>
								{setpstate(true)}
								<PreviewPage />
							</>
						) : isChatOpen ? (
							togChat ? (
								<ChatDetail />
							) : (
								<Groupinformation />
							)
						) : (
							<div style={{ alignItems: 'center' }}>
								<img src={HomePage} className="bg-image" alt="" srcset="" />
								<p style={{ color: 'white' }}>
									Continue a conversation or start a new conversation.
								</p>
							</div>
						)}
					</>
				</div>
			</div>
		</div>
	);
}

export default Whatsapp;
